export const orderStatus = {
    interestSubmitted: 'Interest Submitted',
    awaitingDepositPayment: 'Awaiting Deposit Payment',
    depositPlaced: 'Deposit Placed',
    orderConfirmed: 'Order Confirmed',
    orderCancelled: 'Order Cancelled',
    cancellationPending: 'Cancellation Pending',
    awaitingConfigurationConfirmation: 'Awaiting Configuration Confirmation',
    configurationConfirmed: 'Configuration Confirmed',
    awaitingSalesContractSignature: 'Awaiting B2C Sales Contract Signature',
    salesContractSigned: 'B2C Sales Contract Signed',
    handoverBooked: 'Handover Booked',
    finalBalanceDue: 'Final Balance Due',
    readyForHandover: 'Ready for Handover',
    handoverPending: 'Handover Pending',
    handoverComplete: 'Handover Complete',
};
